import RoomList from './room-list';

const Category = (props) => {
  const { data } = props;
  return (
    <section className="common-sec category-sec clearfix">
      <div className="nvshen-sec">
        <div className="sec-header">
          <i className="icon-index icon-index-nvshen"></i>
          <span className="sec-label">女神</span>
          <a
            href="/systemtag.html?tag=魅力女神"
            className="more-link"
            target="_blank"
            data-sawebclick="id=001t02l02b001"
          >
            更多<i className="icon-index icon-index-more"></i>
          </a>
        </div>
        <div className="star-list">
          <RoomList
            data={{
              list: data.nvshen,
              max: 4,
              saId: '001t02l02+000',
              isLazy: true,
            }}
            clickfrom="J113"
          ></RoomList>
        </div>
      </div>
      <div className="haoshengyin-sec">
        <div className="sec-header">
          <i className="icon-index icon-index-haoshengyin"></i>
          <span className="sec-label">好声音</span>
          <a
            href="/systemtag.html?tag=好声音"
            className="more-link"
            target="_blank"
            data-sawebclick="id=001t02l03b001"
          >
            更多<i className="icon-index icon-index-more"></i>
          </a>
        </div>
        <div className="star-list">
          <RoomList
            data={{
              list: data.haoshengyin,
              max: 4,
              saId: '001t02l03+000',
              isLazy: true,
            }}
            clickfrom="J114"
          ></RoomList>
        </div>
      </div>
      <div className="rewu-sec">
        <div className="sec-header">
          <i className="icon-index icon-index-rewu"></i>
          <span className="sec-label">热舞</span>
          <a
            href="/systemtag.html?tag=天天热舞"
            className="more-link"
            target="_blank"
            data-sawebclick="id=001t02l04b001"
          >
            更多<i className="icon-index icon-index-more"></i>
          </a>
        </div>
        <div className="star-list">
          <RoomList
            data={{
              list: data.rewu,
              max: 4,
              saId: '001t02l04+000',
              isLazy: true,
            }}
            clickfrom="J115"
          ></RoomList>
        </div>
      </div>
    </section>
  );
};

export default Category;
